import { all } from "redux-saga/effects";
import {
  accessTokenWatcher,
  acquiredSourceActionWatcher,
  adminCustomerAccountingWatcher,
  adminCustomerAddressWatcher,
  adminCustomerBnkDetailsWatcher,
  adminCustomerContactPersonWatcher,
  adminCustomerCreateWatcher,
  adminCustomerDeleteWatcher,
  adminCustomerPaymentTermsWatcher,
  adminCustomerTableWatcher,
  adminCustomerUpdateAccountingWatcher,
  adminCustomerUpdateAddressWatcher,
  adminCustomerUpdateBnkDetailsWatcher,
  adminCustomerUpdateContactPersonWatcher,
  adminCustomerUpdatePaymentTermsWatcher,
  adminCustomerUpdateWatcher,
  adminCustomerViewWatcher,
  bloodGroupWatcher,
  discountGroupWatcher,
  genderWatcher,
  groupListWatcher,
  idProofWatcher,
  insuranceWatcher,
  paymentTermsWatcher,
  relationWatcher,
  updateFamilyWatcher,
  updateInsuranceWatcher,
  updatePatientWatcher,
} from "../admin-customer-saga";

export default function* adminCustomerRootSaga() {
  yield all([
    adminCustomerCreateWatcher(),
    adminCustomerUpdateWatcher(),
    adminCustomerContactPersonWatcher(),
    adminCustomerBnkDetailsWatcher(),
    adminCustomerPaymentTermsWatcher(),
    adminCustomerAccountingWatcher(),
    adminCustomerAddressWatcher(),
    adminCustomerTableWatcher(),
    adminCustomerViewWatcher(),
    adminCustomerDeleteWatcher(),
    adminCustomerUpdateContactPersonWatcher(),
    adminCustomerUpdateBnkDetailsWatcher(),
    adminCustomerUpdatePaymentTermsWatcher(),
    adminCustomerUpdateAccountingWatcher(),
    adminCustomerUpdateAddressWatcher(),
    relationWatcher(),
    insuranceWatcher(),
    genderWatcher(),
    bloodGroupWatcher(),
    idProofWatcher(),
    paymentTermsWatcher(),
    groupListWatcher(),
    acquiredSourceActionWatcher(),
    discountGroupWatcher(),
    updatePatientWatcher(),
    updateFamilyWatcher(),
    updateInsuranceWatcher(),
    accessTokenWatcher(),
  ]);
}
